export const isMultiUserOnBoardingOpen = true



// WEBPACK FOOTER //
// ./src/consts/featureFlags.js